/**
 * DevExtreme (ui/tree_list.js)
 * Version: 18.2.3
 * Build date: Wed Nov 07 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./tree_list/ui.tree_list");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme/ui/tree_list.js
// module id = Fg4Q
// module chunks = 0